// client/src/lib/text.ts — text helpers shared by the search boxes.
//
// `fold` was the command palette's own for four milestones (UI-003); the cash ledger's search
// box needs the same folding over a table's rows, and a second copy would be the second place
// „proprietati" stops finding „Proprietăți". Lifted here unchanged.

/** Romanian diacritics fold and lower-case, so „proprietati" finds „Proprietăți". */
export function fold(text: string): string {
  return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}
